import React, { useState, useEffect } from 'react';
import NotificationsView from '../classes/notifications';
import Switch from 'react-switch';

function Notifications(props) {
  const [NotificationsData, setNotificationData] = useState(null);
  const [NotificationsLength, setNotificationsLength] = useState(0);
  const [Checked, setChecked] = useState(false);
  const [RowsSeen, setRowsSeen] = useState(10);

  useEffect(() => {
    const getData = async () => {
      await getNotificationsData();
      props.onContentLoaded();
    };
    getData();
  }, []);

  useEffect(() => {
    if (Checked) {
      setRowsSeen(undefined);
    } else {
      setRowsSeen(10);
    }
  }, [Checked]);

  const handleChange = () => {
    if (Checked) {
      setChecked(false);
    } else {
      setChecked(true);
    }
  };

  const seeMore = (rows) => {
    if (RowsSeen === 10) {
      setRowsSeen(undefined);
    } else {
      setRowsSeen(10);
    }
  };

  const seeMoreHtml = () => {
    // if (props.PlanetPlusItemsLength && props.PlanetPlusItemsLength.length > 10 && !Checked) {
    return (
      <a
        className="btn btn-link-primary margin-bottom-none"
        onClick={() => {
          seeMore();
        }}
      >
        {RowsSeen > 0 ? 'Ver más' : 'Ver menos'}&nbsp;
        <i className={RowsSeen > 0 ? 'icon-arrow-down' : 'icon-arrow-up'} />
      </a>
    );
    // }
  };

  const getNotificationsData = async () => {
    let _notifications = new NotificationsView();
    let _res = await _notifications.getAllNotifications();
    if (_res.data) {
      setNotificationData(_res.data.msgList);
      //   setNotificationsMsg(_res.data.msgList);
    }
  };

  const msgList = () => {
    if (NotificationsData) {
      return Object.values(NotificationsData).map((data, i) => {
        return (
          // <tr onClick={props.openModal}>
          <tr>
            <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
              <i className={data.bms_leido ? 'icon-mail' : 'icon-mail blue'} style={{ fontSize: '20px' }}></i>
            </td>
            <td>{data.bms_clave_seguim}</td>
            <td>{data.bms_fecha_hora}</td>
            <td>{data.bms_autor}</td>
            <td>{data.bms_sector.charAt(0).toUpperCase() + data.bms_sector.slice(1)}</td>
            <td>{formatMsg(data.bms_descripcion)}</td>
          </tr>
        );
      });
    } else {
      return <h6>No hay mensajes</h6>;
    }
  };

  const formatMsg = (linea) => {
    const lineaArray = linea.split(/<\/?b>/g);
    return (
      <h6 className="fs-15">
        {lineaArray.map((word, j) => (
          <React.Fragment key={j}>
            {j == 1 ? <b>{' ' + word}</b> : ' ' + word.replace(/<br>/g, '\r\n')}
          </React.Fragment>
        ))}
      </h6>
    );
  };

  return (
    <>
      <div className="page-title">
        <div className="container">
          <div className="column">
            <h1>
              <i className="icon-bell"></i>&nbsp;Notificaciones
            </h1>
          </div>
        </div>
      </div>
      <Switch
        checkedIcon={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              fontSize: 15,
              color: 'white',
              paddingRight: 2,
            }}
          >
            <i className="icon-inbox" />
          </div>
        }
        uncheckedIcon={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              fontSize: 15,
              color: 'white',
              paddingRight: 2,
            }}
          >
            <i className="icon-x" />
          </div>
        }
        onColor="#ffa000"
        onChange={() => {
          // props.activeFilter();
          handleChange();
        }}
        checked={Checked}
      />
      <div className="container padding-bottom-3x mb-2">
        <div className="row">
          <table className="table table-hover mb-0">
            <thead>
              <tr>
                <th>Leído</th>
                <th>Nº de seguimiento</th>
                <th>Fecha y hora</th>
                <th>Autor</th>
                <th>Sector</th>
                <th>Descripción</th>
              </tr>
            </thead>
            <tbody>{msgList()}</tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Notifications;
